import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { initializePaddle } from '@paddle/paddle-js';
import { GoogleOAuthProvider } from '@react-oauth/google';


initializePaddle({
  token: 'test_57bb4bad1a644b5e93020014669',
  pwCustomer: { },
  environment: 'sandbox'
})

const router = createRouter({ routeTree });
const queryClient = new QueryClient();

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <GoogleOAuthProvider clientId='301706447724-l82cosn2erf3c4u3e945c0i0vqeueii8.apps.googleusercontent.com'>
      <StrictMode>
        <QueryClientProvider client={queryClient}> 
            <RouterProvider router={router} />
        </QueryClientProvider>
      </StrictMode>
    </GoogleOAuthProvider>
  );
}
